<template>
<div class="contents">
  <admin-vehicles-form
    adminType="staff"
    :formMode="formMode"
    :vehicleId="vehicleId"
  />
</div>
</template>

<script>
import AdminVehiclesForm from './../Admin/AdminVehiclesForm.vue'

export default {
  name: 'staff-vehicles-form',
  props: {
    formMode: {
      type: String,
      required: true
    },
    vehicleId: {
      type: Number,
      default: null
    }
  },
  components: {
    AdminVehiclesForm
  }
}
</script>
